import type { RouteRecordRaw } from 'vue-router'

const financeRoutes: RouteRecordRaw[] = [
  {
    path: 'finance/trade-reconciliation',
    name: 'FinanceTradeReconciliation',
    component: () => import('@/pages/finance/trade-reconciliation/index.vue'),
    meta: { title: '导入交易流水审核', parent: '财务管理', requiresPsi: true },
  },
  { path: 'finance/payment-channels', name: 'PaymentChannelSettings', component: () => import('@/pages/finance/payment-channels/index.vue'), meta: { title: '支付渠道配置', parent: '财务管理', requiresPsi: true } },
  { path: 'finance/profit-formula', name: 'ProfitFormulaConfig', component: () => import('@/pages/finance/ProfitFormulaConfigPage.vue'), meta: { title: '毛利公式配置', parent: '财务管理', requiresPsi: true } },
  {
    path: 'finance/shipping-transit-change',
    name: 'ShippingTransitChange',
    component: () => import('@/pages/finance/shipping-transit-change/Index.vue'),
    meta: { title: '发货在途改单', parent: '财务管理', requiresPsi: true },
  },
  {
    path: 'finance/purchase-inbound-settlement',
    name: 'PurchaseInboundSettlement',
    component: () => import('@/pages/finance/purchase-inbound-settlement/Index.vue'),
    meta: {
      title: '采购入库结算',
      parent: '财务管理',
      requiresPsi: true,
    },
  },
  {
    path: 'finance/operating-profit',
    name: 'FinanceOperatingProfit',
    component: () => import('@/pages/finance/FinanceProfitPage.vue'),
    props: { mode: 'overview' },
    meta: { title: '经营利润看板', requiresPsi: true },
  },
  {
    path: 'finance/product-gross-profit',
    name: 'FinanceProductGrossProfit',
    component: () => import('@/pages/finance/FinanceProfitPage.vue'),
    props: { mode: 'products' },
    meta: { title: '商品毛利统计', requiresPsi: true },
  },
  {
    path: 'finance/customer-balance',
    name: 'FinanceCustomerBalance',
    component: () => import('@/pages/finance/CustomerBalanceStatisticsPage.vue'),
    meta: { title: '客户余额统计', requiresPsi: true },
  },
  {
    path: 'finance/fund-account-balance',
    name: 'FinanceFundAccountBalance',
    component: () => import('@/pages/finance/FundAccountBalancePage.vue'),
    meta: { title: '资金账户余额', requiresPsi: true },
  },
  {
    path: 'finance/logistics-reconciliation/import',
    name: 'FinanceLogisticsReconciliationImport',
    component: () => import('@/components/SidebarLogisticsReconciliationView.vue'),
    meta: { title: '物流对账导入', requiresPsi: true },
  },
  {
    path: 'finance/logistics-reconciliation/audit',
    name: 'FinanceLogisticsReconciliationAudit',
    component: () => import('@/components/SidebarLogisticsReconciliationAuditView.vue'),
    meta: { title: '物流对账审核', requiresPsi: true },
  },
  {
    path: 'finance/logistics-reconciliation/unsettled',
    name: 'FinanceLogisticsUnsettledOrder',
    component: () => import('@/components/SidebarLogisticsUnsettledOrderView.vue'),
    meta: { title: '物流未结订单', requiresPsi: true },
  },
  {
    path: 'finance/receipt-accounts',
    name: 'ReceiptAccountSettings',
    component: () => import('@/pages/finance/receipt-accounts/index.vue'),
    meta: {
      title: '收款账户设置',
      parent: '财务管理',
      requiresPsi: true,
    },
  },
]

export default financeRoutes
